import { render } from "./AppNavMenu.vue?vue&type=template&id=ba627566&scoped=true&ts=true"
import script from "./AppNavMenu.vue?vue&type=script&lang=ts"
export * from "./AppNavMenu.vue?vue&type=script&lang=ts"

import "./AppNavMenu.vue?vue&type=style&index=0&id=ba627566&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba627566"]])

export default __exports__